import { render, staticRenderFns } from "./TemplateInheritanceChangeSummaryModal.vue?vue&type=template&id=104c6c2e&"
import script from "./TemplateInheritanceChangeSummaryModal.vue?vue&type=script&lang=ts&"
export * from "./TemplateInheritanceChangeSummaryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports